<clr-modal [clrModalOpen]="messageDialogService.OpenDialog">
  <h3 class="modal-title">
    {{ MessageDialogTitle }}
  </h3>
  <div class="p-2 text-center modal-body">
    <p>{{ MessageDialogMessage }}</p>
  </div>
  <div class="p-2 modal-footer">
    <button
      class="btn btn-primary"
      type="button"
      (click)="MessageDialogOutput.emit(true)"
    >
      Continue
    </button>
    <button
      class="btn btn-secondary"
      type="button"
      (click)="MessageDialogOutput.emit(false)"
      *ngIf="ShowCancel"
    >
      Cancel
    </button>
  </div>
</clr-modal>
